import { render, staticRenderFns } from "./MoneyBoxEditForm.vue?vue&type=template&id=1d572c84"
import script from "./MoneyBoxEditForm.vue?vue&type=script&lang=js"
export * from "./MoneyBoxEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports